import { useSearchParams } from 'react-router-dom'
import useAmicaleValidationAuth from '../auth/useAmicaleValidationAuth'
import AmicaleLoginForm from '../components/AmicaleLoginForm'
import AmicaleValidationDashboard from '../components/AmicaleValidationDashboard'
import AmicaleValidationProductTabs, {
  AMICALE_VALIDATION_TAB,
} from '../components/AmicaleValidationProductTabs'

const EspaceAmicalesPage = () => {
  const { user, client, isAuthenticated, login, logout, loading, error } =
    useAmicaleValidationAuth()
  const [searchParams, setSearchParams] = useSearchParams()

  const productType =
    searchParams.get('productType') || AMICALE_VALIDATION_TAB.HOTEL

  const handleProductTypeChange = (nextType) => {
    const next = new URLSearchParams(searchParams)
    next.set('productType', nextType)
    setSearchParams(next, { replace: true })
  }

  if (!isAuthenticated) {
    return (
      <AmicaleLoginForm onSubmit={login} loading={loading} error={error} />
    )
  }

  return (
    <div className='flex w-full flex-col'>
      <AmicaleValidationProductTabs
        activeTab={productType}
        onChange={handleProductTypeChange}
      />
      <AmicaleValidationDashboard
        user={user}
        client={client}
        onLogout={logout}
      />
    </div>
  )
}

export default EspaceAmicalesPage
